import { render, staticRenderFns } from "./charts-details.vue?vue&type=template&id=6a2dfc94"
import script from "./charts-details.vue?vue&type=script&lang=js"
export * from "./charts-details.vue?vue&type=script&lang=js"
import style0 from "./charts-details.vue?vue&type=style&index=0&id=6a2dfc94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports